import React, { ReactNode } from 'react';
import { Stack, StackProps } from 'react-bootstrap';

import useUiTranslation from 'src/hooks/useUiTranslation';

export interface EmptyProps extends StackProps {
  children: ReactNode;
}
export default function Empty({ children, ...props }: EmptyProps) {
  const { tCommon } = useUiTranslation();
  return (
    <Stack className="d-flex align-items-center gap-5 mb-5" {...props}>
      <div className="text-center mt-5">
        <h1>{tCommon('message.error.noMatchingRecords')}</h1>
      </div>
      <div className="d-flex gap-4">{children}</div>
    </Stack>
  );
}
